import BarcodeScanner from "./BarcodeScanner";
export { default as BarcodeStringFormat } from "./BarcodeStringFormat";
export { BarcodeFormat } from "@zxing/library";
export default BarcodeScanner;
